import { QuestionCircleOutlined } from '@ant-design/icons';
import React                      from 'react';
import { Modal }                  from 'antd';
import { messageErrorIntl }       from 'utils/messageIntl';
import { formatMessageIntl }      from 'utils/messageIntl';
import { messageSuccessIntl }     from 'utils/messageIntl';
import rights                     from 'utils/rights';
import Select                     from 'components/App/IntlSelect';
import FormattedMessageWrapper    from 'components/App/FormattedMessageWrapper';
import MessageMediaModel          from 'models/MessageMediaModel';

interface PlanSelectProps {
  media: MessageMediaModel;
  onMediaDelete: () => void;
}

interface PlanSelectState {
  currentValue: string;
}

class PlanSelect extends React.Component<PlanSelectProps> {
  public state: PlanSelectState = {
    currentValue: 'filename',
  };

  public render() {
    const { media } = this.props;

    const options = [
      {
        label: media.mediaFileName,
        value: 'filename',
      },
      {
        label: <FormattedMessageWrapper id="Télécharger" />,
        value: 'download',
      },
    ];

    if (rights.for.standMedia.delete) {
      options.push({
        label: <FormattedMessageWrapper id="Supprimer" />,
        value: 'delete',
      });
    }

    return (
      <Select
        defaultValue={this.state.currentValue}
        onChange={this.onChange}
        options={options}
        style={{ width: '100%' }}
        value={this.state.currentValue}
      />
    );
  }

  private endDeleteMedia = async () => {
    const { media, onMediaDelete } = this.props;

    media.set('enabled', false);

    try {
      await media.save();
      onMediaDelete();
      messageSuccessIntl("Fichier supprimé !");
    } catch {
      messageErrorIntl("Une erreur s'est produite.");
    }
  };

  private onChange = (value: 'download' | 'delete' | 'filename') => {
    const {
      media,
    } = this.props;

    if (value === 'download') {
      window.open(media.objectUrl, '_blank');
    } else if (value === 'delete') {
      this.startDeleteMedia();
    }
  };

  private startDeleteMedia = () => {
    Modal.confirm({
      cancelText: formatMessageIntl("Annuler"),
      content: (
        <p>
          {formatMessageIntl("Cette opération est irréversible.")}
        </p>
      ),
      icon: <QuestionCircleOutlined style={{ color: '#e74c3c' }} />,
      okText: formatMessageIntl("Oui, confirmer la suppression"),
      onOk: this.endDeleteMedia,
      title: formatMessageIntl("Confirmez-vous la suppression de ce fichier ?"),
    });
  };
}

export default PlanSelect;
